/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReservationRequest } from '../../models/reservation-request';

export interface MedicalAdvisorRequestReservationPost$Params {
      body?: ReservationRequest
}

export function medicalAdvisorRequestReservationPost(http: HttpClient, rootUrl: string, params?: MedicalAdvisorRequestReservationPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, medicalAdvisorRequestReservationPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<string>;
    })
  );
}

medicalAdvisorRequestReservationPost.PATH = '/MedicalAdvisor/RequestReservation';
